import { saveAs } from 'file-saver';

export const exportFile = async (file: Blob, fileName: string) => {
	saveAs(file, fileName, {
		type: 'text/plain;charset=utf-8'
	});
};
